import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/SideBar/SiderBar";
import HeaderBar from "../components/HeadBar/HeadBar";

export default function AdminLayout(){
  const navigate = useNavigate();
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth >= 1024);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved === "true";
  });

  // Pencere boyutu değiştiğinde sidebar durumunu güncelle (isteğe bağlı ama iyi olur)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarVisible(true);
      } else {
        setSidebarVisible(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Global Keyboard Shortcuts
  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      // F1: Ana Sayfa
      if (e.key === "F1") {
        e.preventDefault();
        navigate("/");
      }
      // F2: Satış Yap
      if (e.key === "F2") {
        // If we are on pages where F2 is used for Saving, don't navigate
        const f2SavePages = ["/sales/productsale", "/suppliers/purchase", "/products/add"];
        if (f2SavePages.includes(window.location.pathname)) return;

        e.preventDefault();
        navigate("/sales/productsale");
      }
      // F3: Müşteri Listesi
      if (e.key === "F3") {
        e.preventDefault();
        navigate("/customers");
      }
      // F4: Tedarikçi Listesi
      if (e.key === "F4") {
        e.preventDefault();
        navigate("/suppliers");
      }
      // ESC: Bir önceki sayfaya git
      if (e.key === "Escape") {
        // Eğer ana sayfadaysak bir şey yapma
        if (window.location.pathname === "/") return;

        // Eğer açık bir modal, dialog, takvim veya sidebar varsa navigasyon yapma (ESC önce onları kapatsın)
        const hasOverlay = document.querySelector(
          ".p-component-overlay, .p-dialog-mask, .p-sidebar-mask, .p-datepicker, .p-overlaypanel"
        );
        if (hasOverlay) return;

        e.preventDefault();
        navigate(-1);
      }
    };
    window.addEventListener("keydown", handleGlobalKeyDown, true);
    return () => window.removeEventListener("keydown", handleGlobalKeyDown, true);
  }, [navigate]);

  const handleSidebarToggle = () => {
    if (window.innerWidth >= 1024) {
      const newState = !isCollapsed;
      setIsCollapsed(newState);
      localStorage.setItem("sidebarCollapsed", newState);
    } else {
      setSidebarVisible(!sidebarVisible);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8fafc] flex overflow-x-clip">
      {/* SIDEBAR */}
      <div
        className={`fixed inset-y-0 left-0 z-[2000] no-print
          ${sidebarVisible ? "translate-x-0 shadow-2xl" : "-translate-x-full shadow-none"}
          lg:relative lg:translate-x-0 lg:shadow-none lg:opacity-100
          ${isCollapsed ? "w-[80px] !overflow-visible !transform-none" : "w-[260px] overflow-hidden transition-all duration-300 transform"}
        `}
      >
        <Sidebar visible={true} isCollapsed={isCollapsed} onClose={() => setSidebarVisible(false)} />
      </div>

      {/* MAIN CONTENT AREA */}
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
        <div className="no-print">
          <HeaderBar onSidebarToggle={handleSidebarToggle} />
        </div>

        <main className="flex-1 overflow-y-auto custom-scrollbar bg-[#f8fafc] p-3 lg:p-4">
          {/* Mobil Overlay */}
          {sidebarVisible && (
            <div
              onClick={() => setSidebarVisible(false)}
              className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[1050] lg:hidden transition-opacity duration-300"
            />
          )}

          <div className="max-w-[1600px] mx-auto animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
